import React from 'react';
import { observer } from 'mobx-react';
import trialUserOnboardingState from 'Stores/trialUserOnboardingState';
import { ReactComponent as TimerIcon } from 'Assets/svg/timer-icon.svg';

const TrialEndInfo = observer(props => {
  const { customClass = '' } = props;
  const { trialEndDays } = trialUserOnboardingState;
  return trialEndDays !== '' ? (
    <div className={`trial-end-info ${customClass}`}>
      <TimerIcon />
      <span>
        {trialEndDays === 0
          ? 'Trial ends today'
          : `Trial ends in ${trialEndDays} Days`}
      </span>
    </div>
  ) : (
    ''
  );
});

export { TrialEndInfo };
export default TrialEndInfo;
